import { Button } from '@/components/Button/Button'
import { Loader } from '@/components/Loader/Loader'
import { Popup } from '@/components/Popup/Popup'
import { GeneratorFormContext } from '@/hooks/useGeneratorForm'
import { usePresetsState } from '@/state/presets'
import type { FunctionalComponent } from 'preact'
import { useContext, useState } from 'preact/hooks'
import { useShallow } from 'zustand/shallow'

export const DeletePreset: FunctionalComponent<{
  onCancel: () => void
  onSuccess: () => void
}> = props => {
  const form = useContext(GeneratorFormContext)!

  const presetsStore = usePresetsState(useShallow(
    s => s.list.find(item => item.id === form.presetId),
  ))

  const [preset] = useState(presetsStore)

  const deletePreset = usePresetsState(s => s.delete)

  const [loading, setLoading] = useState(false)

  return (
    <>
      <Popup.Title>
        {preset?.defaultPresetId !== null
          ? `Reset ${preset?.name ?? 'unknown'}`
          : `Delete ${preset?.name ?? 'unknown'}`}
      </Popup.Title>

      <Popup.Fields>
        <Popup.Msg>
          {preset?.defaultPresetId !== null
            ? 'Your customizations will be removed and the default post type will be restored.'
            : 'This post type will be permanently deleted.'}
        </Popup.Msg>
      </Popup.Fields>

      <Popup.Footer>
        <div />
        <Popup.Buttons>
          <Button
            onClick={props.onCancel}
          >
            Cancel
          </Button>
          <Button
            type='primary'
            disabled={loading}
            onClick={async () => {
              try {
                setLoading(true)
                if (!preset?.id) throw new Error('Preset must be defined')
                await deletePreset(preset.id)
                form.setPresetId(null)
                props.onSuccess()
              }
              catch (e) {
                console.error(e)
              }
              finally {
                setLoading(false)
              }
            }}
          >
            {preset?.defaultPresetId !== null ? 'Reset' : 'Delete'}
            {loading && (
              <>
                {' '}
                <Loader />
              </>
            )}
          </Button>
        </Popup.Buttons>
      </Popup.Footer>
    </>
  )
}
